// DO NOT EDIT!!! This file is auto-generated.

export const LOCALES_SUPPORTED = [
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'it',
  'ja',
] as const;
export const LOCALE_DEFAULT: LocaleSupported = 'en';

export async function getMessagesForLocale(
  locale: LocaleSupported = LOCALE_DEFAULT,
): Promise<LocaleMessagesJson> {
  switch (locale) {
    case 'de':
      return import('./locale/de.json');
    case 'en':
      return import('./locale/en.json');
    case 'es':
      return import('./locale/es.json');
    case 'fi':
      return import('./locale/fi.json');
    case 'fr':
      return import('./locale/fr.json');
    case 'it':
      return import('./locale/it.json');
    case 'ja':
      return import('./locale/ja.json');

    default:
      throw new Error('Language not supported');
  }
}

export type LocaleSupported = (typeof LOCALES_SUPPORTED)[number];

export type MessageKey =
  | 'accessibility'
  | 'account_setup_accept_health_data_checkbox'
  | 'account_setup_bullet1'
  | 'account_setup_bullet2'
  | 'account_setup_bullet3'
  | 'account_setup_bullet4'
  | 'account_setup_invalid_link_text'
  | 'account_setup_invalid_link_title'
  | 'account_setup_link_expired_text'
  | 'account_setup_link_expired_title'
  | 'account_setup_marketing_consent_checkbox'
  | 'account_setup_password_success_text'
  | 'account_setup_password_success_title'
  | 'account_setup_resend_email_button'
  | 'account_setup_resend_email_success'
  | 'account_setup_text'
  | 'account_setup_title'
  | 'account_setup_updated_terms_text'
  | 'account_setup_verify_and_save_button'
  | 'app_picker_intro'
  | 'app_picker_ofb_teaser'
  | 'app_picker_ofb_title'
  | 'app_picker_ootw_teaser'
  | 'app_picker_ootw_title'
  | 'app_picker_title'
  | 'chatbot_access_request_access_granted_text'
  | 'chatbot_access_request_access_granted_title'
  | 'chatbot_access_request_button'
  | 'chatbot_access_request_disclaimer'
  | 'chatbot_access_request_link_expired_text'
  | 'chatbot_access_request_link_expired_title'
  | 'chatbot_access_request_paragraph'
  | 'chatbot_access_request_paragraph_2'
  | 'chatbot_access_request_title'
  | 'chatbot_access_request_unknown_error_text'
  | 'chatbot_access_request_unknown_error_title'
  | 'churned_dashboard_please_sync_your_ring_text'
  | 'churned_dashboard_today_generic_text'
  | 'circles_invite_discount'
  | 'circles_invite_get_ring_button'
  | 'circles_invite_intro'
  | 'circles_invite_member_instructions'
  | 'circles_invite_no_oura_ring'
  | 'circles_invite_status_expired'
  | 'circles_invite_status_invalid'
  | 'circles_invite_status_used'
  | 'circles_invite_title'
  | 'coaches_add_coach_email_validation'
  | 'coaches_add_coach_form_validation'
  | 'dashboard_heading_restriction_period_enabled'
  | 'dashboard_last_server_sync_never'
  | 'dashboard_last_server_sync_text'
  | 'dashboard_metric_link_learn'
  | 'dashboard_metric_link_learn_title'
  | 'dashboard_no_active_data_available'
  | 'dashboard_overview_next_day'
  | 'dashboard_overview_previous_day'
  | 'dashboard_section_heading_activity_and_calories'
  | 'dashboard_section_heading_activity_durations'
  | 'dashboard_section_heading_activity_intensity'
  | 'dashboard_section_heading_body_measurements'
  | 'dashboard_section_heading_hr_variability'
  | 'dashboard_section_heading_resting_hr'
  | 'dashboard_section_heading_sleep_stages'
  | 'dashboard_sleep_no_score'
  | 'dashboard_text_restriction_period_enabled'
  | 'daytime_heart_rate_range'
  | 'daytime_heart_rate_single_value'
  | 'deep_link_instructions'
  | 'deep_link_title'
  | 'email_verification_login_link'
  | 'email_verification_success_subtitle'
  | 'email_verification_success_title'
  | 'employee_wellness_no_reports'
  | 'footer_copyright'
  | 'footer_trademark'
  | 'forgot_password_button_submit'
  | 'forgot_password_success_text'
  | 'forgot_password_success_title'
  | 'forgot_password_text'
  | 'forgot_password_title'
  | 'general_abbreviation_body_temperature'
  | 'general_abbreviation_deep_sleep'
  | 'general_abbreviation_inactive_time'
  | 'general_abbreviation_midpoint'
  | 'general_abbreviation_rem_sleep'
  | 'general_abbreviation_sleep_efficiency'
  | 'general_abbreviation_sleep_latency'
  | 'general_abbreviation_sleep_timing'
  | 'general_abbreviation_sleep_total'
  | 'general_abbreviation_total_sleep_time'
  | 'general_activity_balance'
  | 'general_activity_burn'
  | 'general_activity_daily_movement'
  | 'general_activity_score'
  | 'general_activity_score_inactive_time'
  | 'general_activity_score_meet_daily_targets'
  | 'general_activity_score_move_every_hour'
  | 'general_activity_score_recovery_time'
  | 'general_activity_score_training_frequency'
  | 'general_activity_score_training_volume'
  | 'general_average_hr'
  | 'general_average_hrv'
  | 'general_average_met'
  | 'general_average_resting_hr'
  | 'general_awake_time'
  | 'general_bedtime'
  | 'general_body_temperature'
  | 'general_cancel'
  | 'general_category_activity'
  | 'general_category_readiness'
  | 'general_category_sleep'
  | 'general_confirm_password_fieldtext'
  | 'general_daily'
  | 'general_daily_spo2_spo2_average'
  | 'general_date'
  | 'general_date_format_european'
  | 'general_date_format_standard'
  | 'general_date_format_uk'
  | 'general_date_format_us_japan'
  | 'general_deep_sleep'
  | 'general_delete'
  | 'general_email_fieldtext'
  | 'general_error'
  | 'general_error_password_empty'
  | 'general_error_password_no_match'
  | 'general_error_password_too_short'
  | 'general_fair_score_text'
  | 'general_forgot_password_link'
  | 'general_forgot_password_text_with_hub_link'
  | 'general_form_error_email_in_use'
  | 'general_form_error_invalid_credentials'
  | 'general_form_error_invalid_email'
  | 'general_form_error_invalid_token'
  | 'general_form_error_invitation_already_accepted'
  | 'general_form_error_password_too_weak'
  | 'general_form_error_token_expired'
  | 'general_good_score_text'
  | 'general_heart_rate'
  | 'general_heart_rate_daytime'
  | 'general_heart_rate_error_loading_data'
  | 'general_heart_rate_restorative_time'
  | 'general_heart_rate_sleeping_range'
  | 'general_high_activity'
  | 'general_hrv_balance'
  | 'general_inactive_time'
  | 'general_invalid_email'
  | 'general_invalid_link_text'
  | 'general_invalid_link_title'
  | 'general_language_english'
  | 'general_language_finnish'
  | 'general_language_german'
  | 'general_language_japanese'
  | 'general_language_latin_spanish'
  | 'general_language_spanish'
  | 'general_last_month'
  | 'general_last_three_months'
  | 'general_learn_more_text'
  | 'general_light_sleep'
  | 'general_loading'
  | 'general_long_periods_of_inactivity'
  | 'general_low_activity'
  | 'general_lowest_resting_hr'
  | 'general_manage_membership_text'
  | 'general_medium_activity'
  | 'general_meet_daily_targets'
  | 'general_month'
  | 'general_monthly'
  | 'general_move_every_hour'
  | 'general_no_data_available_text'
  | 'general_non_wear_time'
  | 'general_optimal_score_text'
  | 'general_password_fieldtext'
  | 'general_pay_attention_score_text'
  | 'general_previous_day_activity'
  | 'general_previous_night'
  | 'general_reactivate_membership_text'
  | 'general_readiness_score'
  | 'general_readiness_score_activity_balance'
  | 'general_readiness_score_hrv_balance'
  | 'general_readiness_score_previous_day_activity'
  | 'general_readiness_score_previous_night'
  | 'general_readiness_score_recovery_index'
  | 'general_readiness_score_resting_heart_rate'
  | 'general_readiness_score_sleep_balance'
  | 'general_readiness_score_temperature'
  | 'general_recovery_index'
  | 'general_recovery_time'
  | 'general_rem_sleep'
  | 'general_respiratory_rate'
  | 'general_resting_heart_rate'
  | 'general_resting_time'
  | 'general_restless_sleep'
  | 'general_sleep_balance'
  | 'general_sleep_efficiency'
  | 'general_sleep_latency'
  | 'general_sleep_midpoint_time'
  | 'general_sleep_restfulness'
  | 'general_sleep_score'
  | 'general_sleep_score_deep'
  | 'general_sleep_score_efficiency'
  | 'general_sleep_score_latency'
  | 'general_sleep_score_rem'
  | 'general_sleep_score_restfulness'
  | 'general_sleep_score_timing'
  | 'general_sleep_score_total'
  | 'general_sleep_timing'
  | 'general_stay_active'
  | 'general_steps'
  | 'general_target_burn'
  | 'general_temperature_deviation'
  | 'general_temperature_trend_deviation'
  | 'general_this_month'
  | 'general_this_year'
  | 'general_time_format_h12'
  | 'general_time_format_h23'
  | 'general_time_in_bed'
  | 'general_today_scores_loading_error'
  | 'general_total_burn'
  | 'general_total_sleep_time'
  | 'general_training_frequency'
  | 'general_training_volume'
  | 'general_wake_up_time'
  | 'general_walking_equivalency'
  | 'general_weekday_friday'
  | 'general_weekday_monday'
  | 'general_weekday_saturday'
  | 'general_weekday_sunday'
  | 'general_weekday_thursday'
  | 'general_weekday_tuesday'
  | 'general_weekday_wednesday'
  | 'general_weekly'
  | 'general_year'
  | 'guide_infotext_activity_balance'
  | 'guide_infotext_activity_burn'
  | 'guide_infotext_activity_daily_movement'
  | 'guide_infotext_activity_score'
  | 'guide_infotext_avg_hrv'
  | 'guide_infotext_avg_met'
  | 'guide_infotext_awake_time'
  | 'guide_infotext_bedtime'
  | 'guide_infotext_body_temperature'
  | 'guide_infotext_deep_sleep'
  | 'guide_infotext_efficiency'
  | 'guide_infotext_high_activity'
  | 'guide_infotext_inactive_time'
  | 'guide_infotext_light_sleep'
  | 'guide_infotext_long_periods_of_inactivity'
  | 'guide_infotext_low_activity'
  | 'guide_infotext_medium_activity'
  | 'guide_infotext_meet_daily_targets'
  | 'guide_infotext_move_every_hour'
  | 'guide_infotext_previous_day'
  | 'guide_infotext_previous_night'
  | 'guide_infotext_readiness_score'
  | 'guide_infotext_recovery_index'
  | 'guide_infotext_recovery_time'
  | 'guide_infotext_rem_sleep'
  | 'guide_infotext_respiratory_rate'
  | 'guide_infotext_restfulness'
  | 'guide_infotext_resting_heart_rate'
  | 'guide_infotext_resting_time'
  | 'guide_infotext_sleep_balance'
  | 'guide_infotext_sleep_latency'
  | 'guide_infotext_sleep_midpoint_time'
  | 'guide_infotext_sleep_score'
  | 'guide_infotext_sleep_timing'
  | 'guide_infotext_stay_active'
  | 'guide_infotext_steps'
  | 'guide_infotext_total_burn'
  | 'guide_infotext_total_sleep'
  | 'guide_infotext_training_frequency'
  | 'guide_infotext_training_volume'
  | 'guide_infotext_wake_up_time'
  | 'guide_infotext_walking_equivalency'
  | 'guide_page_main_title'
  | 'guide_search_input'
  | 'guide_search_results'
  | 'guide_section_title_activity'
  | 'guide_section_title_readiness'
  | 'guide_section_title_sleep'
  | 'guide_select_metric'
  | 'hide_view_for_unsubscribed_title'
  | 'inactive_subscription_banner_first_paragraph'
  | 'inactive_subscription_banner_second_paragraph'
  | 'inactive_subscription_banner_title'
  | 'integrations_connect_page_back_link'
  | 'integrations_connect_page_connect_error'
  | 'integrations_connect_page_connect_success'
  | 'integrations_connect_page_main_title'
  | 'intellectual_property_notice'
  | 'login_submit_button'
  | 'login_text'
  | 'login_title'
  | 'metric_unit.alerts'
  | 'metric_unit.average_metabolic_equivalents'
  | 'metric_unit.bpm'
  | 'metric_unit.cal'
  | 'metric_unit.duration_hour_minute'
  | 'metric_unit.duration_minute'
  | 'metric_unit.per_minute'
  | 'my_account_applications_api_documentation'
  | 'my_account_applications_button_integrations_connect'
  | 'my_account_applications_button_integrations_disconnect'
  | 'my_account_applications_button_revoke'
  | 'my_account_applications_heading_authorized_apps'
  | 'my_account_applications_heading_authorized_integrations'
  | 'my_account_applications_heading_oura_api'
  | 'my_account_applications_text_no_authorized_apps'
  | 'my_account_applications_text_no_authorized_integrations'
  | 'my_account_applications_text_oura_api'
  | 'my_account_cant_set_primary_email_error'
  | 'my_account_change_password_title'
  | 'my_account_current_password_incorrect'
  | 'my_account_current_password_input'
  | 'my_account_current_password_too_short'
  | 'my_account_delete_account_button'
  | 'my_account_delete_account_email_placeholder'
  | 'my_account_delete_account_paragraph_1'
  | 'my_account_delete_account_paragraph_2'
  | 'my_account_delete_account_paragraph_3'
  | 'my_account_delete_account_title'
  | 'my_account_delete_email_address'
  | 'my_account_delete_email_confimation'
  | 'my_account_delete_email_title'
  | 'my_account_error_locale_settings'
  | 'my_account_export_data_button_export_heartrate_data'
  | 'my_account_export_data_daily_activity'
  | 'my_account_export_data_daily_readiness'
  | 'my_account_export_data_daily_sleep'
  | 'my_account_export_data_daily_spo2'
  | 'my_account_export_data_datatype'
  | 'my_account_export_data_daytime_heart_rate'
  | 'my_account_export_data_ideal_bedtime'
  | 'my_account_export_data_legacy_format_datatype'
  | 'my_account_export_data_legacy_format_heading'
  | 'my_account_export_data_notes_tags'
  | 'my_account_export_data_sleep'
  | 'my_account_export_data_smoothed_location'
  | 'my_account_export_data_text'
  | 'my_account_integrations_slack_link'
  | 'my_account_integrations_text_back_to_account'
  | 'my_account_integrations_text_error_connecting'
  | 'my_account_integrations_text_error_disconnecting'
  | 'my_account_integrations_text_successful_connection'
  | 'my_account_integrations_text_successful_disconnection'
  | 'my_account_locale_preferences_date_format'
  | 'my_account_locale_preferences_first_day'
  | 'my_account_locale_preferences_hour_cycle'
  | 'my_account_locale_preferences_language'
  | 'my_account_locale_preferences_save'
  | 'my_account_locale_preferences_title'
  | 'my_account_manage_in_hub'
  | 'my_account_membership_ended_text'
  | 'my_account_membership_error_loading_text'
  | 'my_account_membership_is_active_text'
  | 'my_account_membership_is_inactive_text'
  | 'my_account_membership_title'
  | 'my_account_new_email_address_label'
  | 'my_account_new_password_confirm_no_match'
  | 'my_account_new_password_input'
  | 'my_account_new_password_too_short'
  | 'my_account_page_main_title'
  | 'my_account_password_info'
  | 'my_account_password_save_button'
  | 'my_account_personal_information_age'
  | 'my_account_personal_information_gender'
  | 'my_account_personal_information_height'
  | 'my_account_personal_information_metric'
  | 'my_account_personal_information_text'
  | 'my_account_personal_information_unit'
  | 'my_account_personal_information_weight'
  | 'my_account_policies_text'
  | 'my_account_revoke_app_title'
  | 'my_account_revoke_app_warning'
  | 'my_account_saved_locale_settings'
  | 'my_account_settings_button_add_another_email'
  | 'my_account_settings_button_add_email'
  | 'my_account_settings_button_change_password'
  | 'my_account_settings_button_email_make_primary'
  | 'my_account_settings_heading_email_addresses'
  | 'my_account_settings_label_name'
  | 'my_account_settings_primary'
  | 'my_account_settings_tooltip_email_not_verified'
  | 'my_account_settings_tooltip_email_verified'
  | 'my_account_subscription_required_app_settings'
  | 'my_account_support_access_rights_column_header_authorized_account'
  | 'my_account_support_access_rights_column_header_expiration'
  | 'my_account_support_access_rights_revoke'
  | 'my_account_support_access_rights_revoke_confirmation'
  | 'my_account_support_access_rights_revoke_modal_title'
  | 'my_account_support_access_rights_valid_until'
  | 'my_account_teams_hrm_button_revoke'
  | 'my_account_teams_hrm_button_share_data'
  | 'my_account_teams_hrm_button_shared'
  | 'my_account_teams_hrm_column_header_group_or_study'
  | 'my_account_teams_hrm_column_header_organization'
  | 'my_account_teams_hrm_column_text_no_organizations'
  | 'my_account_teams_hrm_header_group_type'
  | 'my_account_teams_hrm_header_tags_data'
  | 'my_account_teams_hrm_heading_authorized_organizations'
  | 'my_account_teams_hrm_icon_revoke'
  | 'my_account_teams_revoke_group'
  | 'my_account_teams_revoke_group_title'
  | 'my_account_teams_revoke_org_access'
  | 'my_account_teams_tag_sharing_toggle'
  | 'my_account_title_account_settings'
  | 'my_account_title_applications'
  | 'my_account_title_export_data'
  | 'my_account_title_personal_information'
  | 'my_account_title_policies'
  | 'my_account_title_support_access_rights'
  | 'my_account_title_teams_hrm'
  | 'organization_subscription_banner_review_subscription'
  | 'organization_subscription_banner_seatcount_limit_reached'
  | 'organization_subscription_banner_seatcount_near_limit'
  | 'organization_subscription_banner_seats_used'
  | 'organization_subscription_banner_subscription_expired'
  | 'organization_subscription_banner_subscription_expires_soon'
  | 'oura_teams_privacy_policy'
  | 'page_not_found_body'
  | 'page_not_found_title'
  | 'personal_dashboard_please_sync_your_ring_text'
  | 'privacy_policy'
  | 'reset_password_button_submit'
  | 'reset_password_success_login_link'
  | 'reset_password_success_text'
  | 'reset_password_success_title'
  | 'reset_password_title'
  | 'support_access_rights_access_denied_title'
  | 'support_access_rights_access_granted_text'
  | 'support_access_rights_access_granted_title'
  | 'support_access_rights_approve_button'
  | 'support_access_rights_disclaimer'
  | 'support_access_rights_invalid_link_text'
  | 'support_access_rights_invalid_link_title'
  | 'support_access_rights_link_expired_text'
  | 'support_access_rights_link_expired_title'
  | 'support_access_rights_paragraph_1'
  | 'support_access_rights_paragraph_2'
  | 'support_access_rights_paragraph_3'
  | 'support_access_rights_reject_button'
  | 'support_access_rights_title'
  | 'tag_generic_acne'
  | 'tag_generic_acupuncture'
  | 'tag_generic_air_conditioning'
  | 'tag_generic_airplane'
  | 'tag_generic_airquality'
  | 'tag_generic_allergies'
  | 'tag_generic_anger'
  | 'tag_generic_anxiety'
  | 'tag_generic_awe'
  | 'tag_generic_baby_care'
  | 'tag_generic_back_pain'
  | 'tag_generic_beer'
  | 'tag_generic_birth'
  | 'tag_generic_birth_control'
  | 'tag_generic_bloating'
  | 'tag_generic_blooddonation'
  | 'tag_generic_breastfeeding'
  | 'tag_generic_breathwork'
  | 'tag_generic_bright_bedroom'
  | 'tag_generic_caffeine'
  | 'tag_generic_car'
  | 'tag_generic_cbd'
  | 'tag_generic_chiropractic'
  | 'tag_generic_coffee'
  | 'tag_generic_cold'
  | 'tag_generic_cold_exposure'
  | 'tag_generic_cold_shower'
  | 'tag_generic_collagen'
  | 'tag_generic_compression'
  | 'tag_generic_connected'
  | 'tag_generic_covid19'
  | 'tag_generic_covid19_vaccine'
  | 'tag_generic_cpap'
  | 'tag_generic_cramps'
  | 'tag_generic_crying'
  | 'tag_generic_cryotherapy'
  | 'tag_generic_dark_bedroom'
  | 'tag_generic_diarrhea'
  | 'tag_generic_difficulty_concentrating'
  | 'tag_generic_emergency_contraceptive'
  | 'tag_generic_emotionally_exhausted'
  | 'tag_generic_energized'
  | 'tag_generic_erectile_dysfunction'
  | 'tag_generic_excited'
  | 'tag_generic_fasting'
  | 'tag_generic_fatigue'
  | 'tag_generic_fever'
  | 'tag_generic_float_tank'
  | 'tag_generic_flu'
  | 'tag_generic_flu_shot'
  | 'tag_generic_foam_roller'
  | 'tag_generic_forgetfulness'
  | 'tag_generic_gratitude'
  | 'tag_generic_hangover'
  | 'tag_generic_happy'
  | 'tag_generic_headache'
  | 'tag_generic_heat_training'
  | 'tag_generic_highaltitude'
  | 'tag_generic_homeoffice'
  | 'tag_generic_hormone_replacement_therapy'
  | 'tag_generic_hot_flashes'
  | 'tag_generic_hot_shower'
  | 'tag_generic_hotel'
  | 'tag_generic_hyperbaric_oxygen_therapy'
  | 'tag_generic_in_control'
  | 'tag_generic_indigestion'
  | 'tag_generic_injured'
  | 'tag_generic_insomnia'
  | 'tag_generic_insulin'
  | 'tag_generic_irritability'
  | 'tag_generic_jetlag'
  | 'tag_generic_joint_pain'
  | 'tag_generic_ketodiet'
  | 'tag_generic_kids'
  | 'tag_generic_late_workout'
  | 'tag_generic_lighttherapy'
  | 'tag_generic_liquor'
  | 'tag_generic_lonely'
  | 'tag_generic_love'
  | 'tag_generic_low_motivation'
  | 'tag_generic_low_sexual_desire'
  | 'tag_generic_low_sperm_count'
  | 'tag_generic_magnesium'
  | 'tag_generic_massage'
  | 'tag_generic_mastitis'
  | 'tag_generic_medication'
  | 'tag_generic_meditation'
  | 'tag_generic_melatonin'
  | 'tag_generic_menopause_symptoms'
  | 'tag_generic_migraine'
  | 'tag_generic_mood_swings'
  | 'tag_generic_muscle_stimulator'
  | 'tag_generic_nap'
  | 'tag_generic_nasal_congestion'
  | 'tag_generic_nausea'
  | 'tag_generic_nicotine'
  | 'tag_generic_night_sweats'
  | 'tag_generic_no_alcohol'
  | 'tag_generic_no_late_meal'
  | 'tag_generic_no_late_workout'
  | 'tag_generic_no_medication'
  | 'tag_generic_no_melatonin'
  | 'tag_generic_no_nap'
  | 'tag_generic_nocaffeine'
  | 'tag_generic_office'
  | 'tag_generic_outdoors'
  | 'tag_generic_overwhelmed'
  | 'tag_generic_ovulation'
  | 'tag_generic_pain'
  | 'tag_generic_pain_killer'
  | 'tag_generic_party'
  | 'tag_generic_perimenopause_symptoms'
  | 'tag_generic_period'
  | 'tag_generic_period_start'
  | 'tag_generic_pets'
  | 'tag_generic_physically_exhausted'
  | 'tag_generic_physiotherapy'
  | 'tag_generic_pms'
  | 'tag_generic_positive_lh_test'
  | 'tag_generic_positive_pregnancy_test'
  | 'tag_generic_postmenopause_symptoms'
  | 'tag_generic_pregnancy_loss'
  | 'tag_generic_pregnant'
  | 'tag_generic_reading_before_bed'
  | 'tag_generic_relaxed'
  | 'tag_generic_sad'
  | 'tag_generic_sex'
  | 'tag_generic_shared_bed'
  | 'tag_generic_shift_work'
  | 'tag_generic_sick'
  | 'tag_generic_sleep_mask'
  | 'tag_generic_sleep_therapy'
  | 'tag_generic_slept_alone'
  | 'tag_generic_socialgathering'
  | 'tag_generic_sore_throat'
  | 'tag_generic_soreness'
  | 'tag_generic_spicy_meal'
  | 'tag_generic_spotting'
  | 'tag_generic_steam_room'
  | 'tag_generic_sugar'
  | 'tag_generic_sun'
  | 'tag_generic_sunlight_alarm'
  | 'tag_generic_sunrise_exposure'
  | 'tag_generic_sunset_exposure'
  | 'tag_generic_supplements'
  | 'tag_generic_surgery'
  | 'tag_generic_tea'
  | 'tag_generic_theragun'
  | 'tag_generic_tired'
  | 'tag_generic_train'
  | 'tag_generic_travel'
  | 'tag_generic_urinary_issues'
  | 'tag_generic_vacation'
  | 'tag_generic_vaccination'
  | 'tag_generic_vaginal_dryness'
  | 'tag_generic_valerian'
  | 'tag_generic_weighted_blanket'
  | 'tag_generic_wind_down_routine'
  | 'tag_generic_wine'
  | 'tag_generic_work'
  | 'tag_health_consent'
  | 'tag_health_consent_button'
  | 'tag_health_consent_title'
  | 'tag_rest_mode'
  | 'tag_sleep_aid'
  | 'tag_sleep_alcohol'
  | 'tag_sleep_blackoutcurtains'
  | 'tag_sleep_bluelightblockers'
  | 'tag_sleep_dreams'
  | 'tag_sleep_earplugs'
  | 'tag_sleep_fullmoon'
  | 'tag_sleep_late_coffee'
  | 'tag_sleep_late_hotbath'
  | 'tag_sleep_late_screentime'
  | 'tag_sleep_latemeal'
  | 'tag_sleep_latework'
  | 'tag_sleep_newbed'
  | 'tag_sleep_nightguard'
  | 'tag_sleep_nightmares'
  | 'tag_sleep_noisy'
  | 'tag_sleep_sauna'
  | 'tag_sleep_snoring'
  | 'tag_sleep_sounds'
  | 'tag_sleep_story'
  | 'tag_sleep_stress'
  | 'tag_sleep_temp_high'
  | 'tag_sleep_temp_low'
  | 'tag_sleep_whitenoise'
  | 'tag_story'
  | 'tags_and_notes_not_available_update_app'
  | 'tags_and_notes_permission_denied'
  | 'tags_and_notes_permission_denied_instructions'
  | 'tags_and_notes_unable_to_fetch'
  | 'tags_generic_reward_title'
  | 'tags_header'
  | 'tags_no_tags_in_time_range'
  | 'tags_open_tags_from_date'
  | 'tags_summary_between_dates'
  | 'tags_summary_from_start'
  | 'teams_data_files_custom_daily_intro'
  | 'teams_data_files_custom_daily_title'
  | 'teams_data_files_custom_interval_intro'
  | 'teams_data_files_custom_interval_title'
  | 'teams_data_files_custom_intro'
  | 'teams_data_files_custom_title'
  | 'teams_data_files_group_intro'
  | 'teams_data_files_group_title'
  | 'teams_data_files_intro'
  | 'teams_data_files_label_data_type'
  | 'teams_data_files_label_data_type_tooltip'
  | 'teams_data_files_label_data_type_tooltip_teaser'
  | 'teams_data_files_label_data_types'
  | 'teams_data_files_label_date'
  | 'teams_data_files_label_member'
  | 'teams_data_files_label_members'
  | 'teams_data_files_max_files_warning'
  | 'teams_data_files_teaser_optin'
  | 'teams_data_files_teaser_optout'
  | 'terms_and_conditions'
  | 'terms_and_privacy_policy_updated_submit_button'
  | 'terms_and_privacy_policy_updated_title'
  | 'terms_of_service'
  | 'terms_of_use'
  | 'top_navigation_my_account'
  | 'top_navigation_sign_out'
  | 'trends_add_chart'
  | 'trends_button_download_data'
  | 'trends_correlation_between_metrics'
  | 'trends_correlation_between_metrics_with_day_offset'
  | 'trends_correlation_minus_one_day'
  | 'trends_correlation_negative'
  | 'trends_correlation_none'
  | 'trends_correlation_offset'
  | 'trends_correlation_plus_one_day'
  | 'trends_correlation_positive'
  | 'trends_correlation_with_day_offset'
  | 'trends_correlation_with_metric_and_day_offset'
  | 'trends_date_pagination_next_days'
  | 'trends_date_pagination_previous_days'
  | 'trends_date_picker_cancel'
  | 'trends_date_picker_input_enddate'
  | 'trends_date_picker_input_startdate'
  | 'trends_date_picker_submit'
  | 'trends_date_range_custom'
  | 'trends_date_range_label'
  | 'trends_date_slider_title'
  | 'trends_day_letters'
  | 'trends_download_data_button_download'
  | 'trends_download_data_for_time_period'
  | 'trends_download_data_instructions'
  | 'trends_download_data_metric_placeholder'
  | 'trends_download_data_multi_select_name'
  | 'trends_metric_correlation_heading_correlation'
  | 'trends_metric_correlation_not_enough_data'
  | 'trends_metric_correlation_not_enough_data_explanation'
  | 'trends_metric_correlation_placeholder'
  | 'trends_metric_correlation_r'
  | 'trends_metric_correlation_the_previous_day'
  | 'trends_metric_correlation_the_same_day'
  | 'trends_metric_correlation_the_the_following_day'
  | 'trends_metric_correlation_unknown_correlation'
  | 'trends_metric_pearson_correlation_coefficient'
  | 'trends_metric_pearson_correlation_coefficient_text'
  | 'trends_moderate_correlation'
  | 'trends_no_correlation'
  | 'trends_period_daily'
  | 'trends_period_monthly'
  | 'trends_period_weekly'
  | 'trends_select_metric'
  | 'trends_strong_correlation'
  | 'trends_trend_period_label'
  | 'trends_weak_correlation';

export type LocaleMessagesJson = Record<MessageKey, string>;
